import { render, staticRenderFns } from "./ForumInfo.vue?vue&type=template&id=0c278cbb&scoped=true&"
import script from "./ForumInfo.vue?vue&type=script&lang=js&"
export * from "./ForumInfo.vue?vue&type=script&lang=js&"
import style0 from "./ForumInfo.vue?vue&type=style&index=0&id=0c278cbb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c278cbb",
  null
  
)

export default component.exports